// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".activeLabel[data-v-5df66b4c] {\n  background: #eb5757;\n  color: #ffffff;\n  font-size: 9px;\n}\n.dot[data-v-5df66b4c] {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #ffffff;\n  -webkit-animation: blinker-5df66b4c 1.5s linear infinite;\n          animation: blinker-5df66b4c 1.5s linear infinite;\n}\n@-webkit-keyframes blinker-5df66b4c {\n50% {\n    opacity: 0;\n}\n}\n@keyframes blinker-5df66b4c {\n50% {\n    opacity: 0;\n}\n}", ""]);
// Exports
module.exports = exports;
